import React, {Fragment, useRef, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useStateContext} from "../contexts/ContextProvider";
import {login} from "../api/apiClient";

const LoginSignupPage = () => {
    const [errors, setErrors] = useState(null);
    const {setUser, setToken} = useStateContext();
    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const handleSubmit = (e) => {
        e.preventDefault();

        const email = emailRef.current.value;
        const password = passwordRef.current.value;

        if (!email || !password) {
            setErrors({
                email: ["E-Mail ist erforderlich."],
                password: ["Passwort ist erforderlich."],
            });
            return;
        }

        setErrors(null);

        login(email, password)
            .then((data) => {
                setUser({
                    firstName: data.user.firstName,
                    lastName: data.user.lastName,
                    email: data.user.email,
                });

                setToken(data.token);

                const from = location.state?.from || "/";
                navigate(from);
            })
            .catch((err) => {
                const response = JSON.parse(err.message);

                if (response && response.status === 422) {
                    setErrors(response.data.errors);
                }

                if (response && response.status === 400) {
                    setErrors({
                        email: [response.data.message],
                    });
                }

                window.scrollTo(0, 0);
            });
    };

    return (
        <Fragment>
            <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center">
                <div className="w-full max-w-4xl bg-white shadow-lg rounded-lg p-6 flex flex-col md:flex-row">
                    {/* Left Section - Login */}
                    <div className="flex-1 border-r-0 md:border-r-2 border-gray-200 px-8 mb-6 md:mb-0">
                        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                            Willkommen zurück!
                        </h2>
                        <p className="text-gray-500 mb-6">In deinen Account einloggen</p>
                        {/* Display Errors */}
                        {errors && (
                            <div className="text-red-500 mb-4">
                                {Object.keys(errors).map((key) => (
                                    <p key={key}>{errors[key][0]}</p>
                                ))}
                            </div>
                        )}
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    E-Mail*
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    ref={emailRef}
                                    className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:ring-pegasusPurple focus:border-pegasusPurple"
                                    placeholder="Deine E-Mail"
                                />
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="password"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Passwort*
                                </label>
                                <div className="relative">
                                    <input
                                        type="password"
                                        id="password"
                                        ref={passwordRef}
                                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:ring-pegasusPurple focus:border-pegasusPurple"
                                        placeholder="Dein Passwort"
                                    />
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="w-full bg-pegasusPurple text-white py-2 px-4 rounded-md hover:bg-pegasusPurpleHover"
                            >
                                EINLOGGEN
                            </button>
                            <p className="text-sm text-center text-pegasusPurple mt-4 cursor-pointer">
                                <Link to="/forgot-password">Passwort vergessen?</Link>
                            </p>
                            {/* Mobile-specific Signup Link */}
                            <div className="block md:hidden text-center mt-4">
                                <p className="text-sm text-gray-500">
                                    New?{" "}
                                    <Link
                                        to="/signup"
                                        className="text-pegasusPurple underline"
                                    >
                                        Erstelle einen Account
                                    </Link>
                                </p>
                            </div>
                        </form>
                    </div>

                    {/* Right Section - Signup */}
                    <div className="hidden md:flex flex-1 px-8 text-center flex-col justify-center">
                        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                            Sign up
                        </h2>
                        <p className="text-gray-500 mb-4">
                            Noch kein Mitglied? Jetzt registrieren!
                        </p>
                        <p className="text-gray-500 mb-6">
                            Um einen Termin zu buchen, musst du ein Benutzerkonto erstellen.
                        </p>
                        <button
                            className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                            onClick={() => navigate("/signup", { state: { from: location.state?.from || "/" } })}
                        >
                            JETZT REGISTRIEREN
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default LoginSignupPage;
